import API from './office.instance';

const POST = async (endpoint, obj) => {
  // API.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
  // API.defaults.withCredentials = false;
  return await API.post(endpoint, obj)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return {
        data: {
          Retorno: {
            status: 1,
            msg: err,
          },
        },
      };
    });
};

const GET = async (endpoint) => {
  // API.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
  // API.defaults.withCredentials = false;
  return await API.get(endpoint)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return {
        data: {
          Retorno: {
            status: 1,
            msg: err,
          },
        },
      };
    });
};

export async function Logar(obj) {
  return await POST('/office/AutoAtendimento/Login', obj);
}

export async function GetDadosApp(obj) {
  return await POST('office/AutoAtendimento/GetDadosApp/', obj);
}

export async function GetDadosEmpresaConfig(obj) {
  return await POST('office/AutoAtendimento/GetEmpresaConfig/', obj);
}

export async function GerarGuidSessaoPagSeguro(obj) {
  return await POST('office/api/pagamento/consultar/', obj);
}

export async function GeraNumeroPedido() {
  return await POST('/office/AutoAtendimento/GeraNumeroPedido/');
}

export async function QlubPostOrderDetails(payload) {
  return await POST('/office/AutoAtendimento/QlubPostOrderDetails', payload);
}

export async function GetPedidos(idCliente) {
  return await POST('/office/AutoAtendimento/GetPedidos/', idCliente);
}

export async function EnviaPedido(obj) {
  return await POST('/office/api/integracao/pedido/', obj);
}

export async function RealizaPagamentoAutoAtendimento(obj) {
  return await POST('/office/api/integracao/RealizaPagamentoAutoAtendimento/', obj);
}

export async function GetEnderecos(obj) {
  return await POST('/office/AutoAtendimento/GetEnderecos', obj);
}

export async function GetCep(cep) {
  return await GET(`https://viacep.com.br/ws/${cep}/json/`);
}

export async function ConsultaCep(obj) {
  return await POST('/office/AutoAtendimento/ConsultaCep', obj);
}

export async function GetIpPublic() {
  return await GET(`https://geolocation-db.com/json/`);
}

export async function GetDistance(obj) {
  return await POST('/office/AutoAtendimento/GetEnderecoDistancia', obj);
}

export async function SalvarEndereco(obj) {
  return await POST('/office/AutoAtendimento/CadastrarEndereco', obj);
}

export async function SalvarDadosCliente(obj) {
  return await POST('/office/AutoAtendimento/Cadastro', obj);
}

export async function ExcluirEndereco(idEndereco) {
  return await POST('/office/AutoAtendimento/ExcluirEndereco', idEndereco);
}

export async function ReenviarSenha(obj) {
  return await POST('/office/AutoAtendimento/ReenviarSenha', obj);
}

export async function SolicitarCodigoSmsPorTelefone(obj) {
  return await POST('/office/AutoAtendimento/SolicitarCodigoSmsPorTelefone', obj);
}

export async function ValidarCodigoSmsPorTelefone(obj) {
  return await POST('/office/AutoAtendimento/ValidarCodigoSmsPorTelefone', obj);
}

export async function SalvarCartao(obj) {
  return await POST('/office/api/pagamento/salvarcartao', obj);
}

export async function ExcluirCartao(obj) {
  return await POST('/office/api/pagamento/excluircartao', obj);
}

export async function GetCartoes(obj) {
  return await POST('/office/api/pagamento/listarcartoes', obj);
}

export async function EfetuarPagamento(obj) {
  return await POST('/office/api/pagamento/credito', obj);
}

export async function GetDadosPix(obj) {
  return await POST('/office/AutoAtendimento/GetDadosPix/', obj);
}

export async function ConsultaClientePortaria(obj) {
  return await POST('office/AutoAtendimento/ConsultaClientePortaria/', obj);
}

export async function SetPreCadastroPortaria(obj) {
  return await POST('office/AutoAtendimento/SetPreCadastroPortaria/', obj);
}

export async function ExcluirDesativarConta(obj) {
  return await POST('office/AutoAtendimento/ExcluirDesativarConta/', obj);
}

export async function StripeCreatePaymentIntent(obj) {
  return await POST('office/AutoAtendimento/StripeCreatePaymentIntent/', obj);
}
